/**
 * KAN-788: атрибуты лида организации (KAN-783) для фильтра списка клиентов.
 * Берутся из тех же настроек, что и страница настроек (общий кэш ['settings']).
 * Все атрибуты, не только show_in_crm. Пока не загружено или загрузка упала
 * (нет права settings.view): undefined.
 */
import { useQuery } from '@tanstack/react-query';
import { settingsApi } from '@/services/api/settings';
import type { LeadAttribute, Settings } from '@/types/settings';

const selectLeadAttributes = (settings: Settings): LeadAttribute[] => settings.organization?.lead_attributes ?? [];

export function useLeadAttributes(): LeadAttribute[] | undefined {
  const { data } = useQuery({
    queryKey: ['settings'],
    queryFn: settingsApi.getSettings,
    select: selectLeadAttributes,
    staleTime: 30_000,
  });
  return data;
}
